import { matchupCentreIndex } from '~/search-domain/indexes';
import { buildMatchupCentreQuery } from '~/search-domain/pipelines/match-centre/build-query';
import {
  getMatchupCentreBaseFilters,
  getMatchupCentreFacetAttributes,
  getMatchupCentreSearchSettings,
  getMatchupCentreSorting,
} from '~/search-domain/pipelines/match-centre/query-config';
import { transformMatchupCentreResponse } from '~/search-domain/pipelines/match-centre/transform-response';
import { type MatchupCentreESResultBody } from '~/search-domain/pipelines/match-centre/types';
import { type SearchPipelineDefinition, type SearchUiState } from '~/search-domain/types';

const resolveMatchupCentreSorting = (context: Parameters<typeof getMatchupCentreSorting>[0]) =>
  getMatchupCentreSorting(context);

export const matchupCentrePipelineDefinition: SearchPipelineDefinition<SearchUiState, MatchupCentreESResultBody> = {
  buildSearchRequest: buildMatchupCentreQuery,
  facetAttributes: context => getMatchupCentreFacetAttributes(context),
  getBaseFilters: context => getMatchupCentreBaseFilters(context),
  getSearchUiConfig: context => ({
    searchAttributes: getMatchupCentreSearchSettings().search ?? [],
    sorting: () => resolveMatchupCentreSorting(context),
  }),
  getSorting: context => resolveMatchupCentreSorting(context),
  id: matchupCentreIndex,
  searchSettings: () => getMatchupCentreSearchSettings(),
  transformResponse: transformMatchupCentreResponse,
};
